var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFast = function SvgFast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.803 20.685c0 11.102 9.05 20.133 20.174 20.133 11.124 0 20.173-9.03 20.173-20.133C69.15 9.583 60.1.553 48.977.553c-11.123 0-20.174 9.03-20.174 20.132Zm2.518.002c0-9.715 7.92-17.62 17.656-17.62 9.735 0 17.655 7.905 17.655 17.62 0 9.714-7.92 17.619-17.655 17.619-9.736 0-17.656-7.904-17.656-17.62Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.854 23.487h.433l-.069-.054a1.256 1.256 0 0 0 .895-1.203V10.645c0-.694-.564-1.256-1.259-1.256-.694 0-1.259.562-1.259 1.257v9.664l-9.986-4.352a1.257 1.257 0 1 0-1.008 2.303l11.749 5.121c.162.07.333.105.504.105ZM2.109 23.486h18.627l1.108-1.258h.15c0-.694-.563-1.257-1.258-1.257H2.109a1.258 1.258 0 1 0 0 2.515ZM7.674 14.939h18.627l1.109-1.257h.15c0-.695-.564-1.258-1.259-1.258H7.674a1.258 1.258 0 1 0 0 2.515ZM7.674 32.032h18.627l1.109-1.257h.15c0-.694-.564-1.257-1.259-1.257H7.674a1.258 1.258 0 1 0 0 2.514Z",
    fill: "#07D170",
    stroke: "#07D170",
    strokeWidth: 0.3
  })));
};

export default SvgFast;